import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../storage/contexts/UserContext";
import FadeIn from "react-fade-in";
import axios from "axios";
import {
  DELETE_ORGANISATION_QUESTIONNAIRE,
  GET_ORGANISATION_QUESTIONNAIRES,
} from "../../../../Routes";
import { generateURLOptions } from "../../../../URLOptions";
import CommonQuestionnaireCard from "../../../../InterstellrComponents/CommonQuestionnaireCard";

import { FaPencil } from "react-icons/fa6";
import FilledButton from "../../../../InterstellrComponents/FilledButton";
import { useNavigate } from "react-router";

const OrganisationQuestionnaires = () => {
  const navigate = useNavigate();
  const { profile } = useContext(UserContext);
  const [questionnaires, setQuestionnaires] = useState(null);

  const getOrganisationQuestionnaires = async () => {
    try {
      const response = await axios.get(GET_ORGANISATION_QUESTIONNAIRES, {
        headers: generateURLOptions(),
      });

      console.log("Organisation Questionniares: ", response.data.data);
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      setQuestionnaires(response.data.data);
    } catch (error) {
      return alert(error);
    }
  };

  const deleteOrganisationQuestionnaire = async (questionnaireId) => {
    try {
      const response = await axios.delete(DELETE_ORGANISATION_QUESTIONNAIRE, {
        data: { questionnaireId },
        headers: generateURLOptions(),
      });

      console.log("Organisation Questionniares: ", response.data.data);
      if (response?.data?.success === false) {
        alert(response?.data?.message ?? "");
        return;
      }

      getOrganisationQuestionnaires();
    } catch (error) {
      return alert(error);
    }
  };

  useEffect(() => {
    getOrganisationQuestionnaires();
  }, []);

  return (
    <>
      <div
        className="w-screen h-[90vh] overflow-scroll"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <div className="container mx-auto flex flex-col justify-start mt-24 items-center h-full w-full">
          <div className="w-full md:w-2/3 px-6 md:px-0">
            <FadeIn delay={200}>
              <div className="flex flex-col mb-4">
                <div className="flex flex-col">
                  <div className="flex flex-row">
                    <h4 className="font-normal text-black text-2xl">
                      Organisation Questionnaires
                    </h4>

                    <div style={{ flex: 1 }} />

                    <div className="w-1/4">
                      <FilledButton
                        text={"Create"}
                        onPress={() =>
                          navigate("/manager/questionnaires/create")
                        }
                      />
                    </div>
                  </div>

                  <h5 className="font-semibold text-black text-3xl mt-1 mb-4">
                    {profile?.company_id?.company_name ??
                      profile?.firstName ??
                      ""}
                  </h5>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={350}>
              <div className="flex flex-col w-full">
                <p className="text-slate-500 font-medium mb-1">
                  Draft Questionnaires
                </p>
                {questionnaires?.drafts?.length > 0 ? (
                  questionnaires?.drafts?.map((data) => (
                    <CommonQuestionnaireCard
                      key={data?._id}
                      item={data}
                      admin={true}
                      onDelete={deleteOrganisationQuestionnaire}
                    />
                  ))
                ) : (
                  <div className="bg-white shadow-md flex flex-row items-center p-6 rounded-xl mt-2">
                    <FaPencil className="text-mpPurple text-2xl" />

                    <p className="ml-4 text-black font-medium text-base">
                      Your Draft questionnaires will appear here
                    </p>
                  </div>
                )}
              </div>

              <div className="flex flex-col w-full mt-8">
                <p className="text-slate-500 font-medium mb-1">
                  Active Questionnaires
                </p>
                {questionnaires?.pending?.length > 0 ? (
                  questionnaires?.pending?.map((data) => (
                    <CommonQuestionnaireCard
                      key={data?._id}
                      item={data}
                      admin={true}
                      pending={true}
                      onDelete={deleteOrganisationQuestionnaire}
                    />
                  ))
                ) : (
                  <div className="bg-white shadow-md flex flex-row items-center p-6 rounded-xl mt-2">
                    <img
                      className="w-8 h-8 object-contain"
                      alt={"Active Questionnaires"}
                      src={require("../../../../assets/images/ic_pending.png")}
                    />
                    <p className="ml-4 text-black font-medium text-base">
                      Your active questionnaires will appear here
                    </p>
                  </div>
                )}
              </div>

              <div className="flex flex-col w-full mt-8">
                <p className="text-slate-500 font-medium mb-1">
                  Completed Questionnaires
                </p>
                {questionnaires?.previous?.length > 0 ? (
                  questionnaires?.previous?.map((data) => (
                    <CommonQuestionnaireCard
                      key={data?._id}
                      item={data}
                      admin={true}
                      previous={true}
                      onDelete={deleteOrganisationQuestionnaire}
                    />
                  ))
                ) : (
                  <div className="bg-white shadow-md flex flex-row items-center p-6 rounded-xl mt-2">
                    <img
                      className="w-8 h-8 object-contain"
                      alt={"Completed Questionnaires"}
                      src={require("../../../../assets/images/ic_previous.png")}
                    />
                    <p className="ml-4 text-black font-medium text-base">
                      Your completed questionnaires will appear here
                    </p>
                  </div>
                )}
              </div>

              <div className="h-24" />
            </FadeIn>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrganisationQuestionnaires;
